/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Guide_Experiences_P1Inputs */

const es_marketplace_seo_spain_guide_experiences_p1 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Experiences_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Además del alquiler por días, en Zarpar hay excursiones en barco: paseos al atardecer, rutas a islas, avistamiento de delfines, degustación de marisco a bordo o salidas de pesca.`)
};

const gl_marketplace_seo_spain_guide_experiences_p1 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Experiences_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ademais do alugueiro por días, en Zarpar hai excursiones en barco: paseos ao solpor, rutas a illas, avistamento de golfiños, degustación de marisco a bordo ou saídas de pesca.`)
};

const en_marketplace_seo_spain_guide_experiences_p1 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_Experiences_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beyond day charters, Zarpar offers boat trips: sunset cruises, island routes, dolphin watching, onboard seafood tastings and fishing outings.`)
};

/**
* | output |
* | --- |
* | "Beyond day charters, Zarpar offers boat trips: sunset cruises, island routes, dolphin watching, onboard seafood tastings and fishing outings." |
*
* @param {Marketplace_Seo_Spain_Guide_Experiences_P1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_guide_experiences_p1 = /** @type {((inputs?: Marketplace_Seo_Spain_Guide_Experiences_P1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Guide_Experiences_P1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_guide_experiences_p1(inputs)
	if (locale === "en") return en_marketplace_seo_spain_guide_experiences_p1(inputs)
	return es_marketplace_seo_spain_guide_experiences_p1(inputs)
});